import BaseViewController from "./base-view-controller";
import { buildCaseList } from "../utils/case-list-builder";

class SectionedListViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    return { ...values, ...this.formState };
  }

  buildScreenSection({ section_title, rows }) {
    const handleButtonClick = this.handleButtonClick.bind(this);

    const caseLists = buildCaseList(
      rows,
      this.components,
      handleButtonClick,
      this.appData.settings
    );
    return [
      { type: "text", params: "TDFieldOptionBold", title: section_title },
      ...caseLists
    ];
  }

  preprocessScreenData() {
    const { list_data } = this.screen.data;
    this.screen = {
      ...this.screen,
      fields: [
        ...this.buildScreenSection(list_data[0]),
        ...this.buildScreenSection(list_data[1])
      ]
    };
  }

  handleButtonClick(name, text, action) {
    if (name === "selectedData") {
      this.formState = { ...text };
    }
    super.handleButtonClick(name, text, action);
  }
}

export default SectionedListViewController;
